import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const WEBCHAT_HOST = ConfigurationService.get(ConfigurationKeys.WEB_CHAT_HOST);
const GET_ENCRYPTED_USERNAMES_URL = `${WEBCHAT_HOST}kiiroo-encryptions`;
const GET_LOVENSE_DATA_URL_BASE = `${WEBCHAT_HOST}kiiroo-callbacks`;
const PLATFORM = 'Cam4';

export {
  GET_ENCRYPTED_USERNAMES_URL,
  GET_LOVENSE_DATA_URL_BASE,
  PLATFORM,
  WEBCHAT_HOST,
};
